/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { gql, useLazyQuery } from '@apollo/client';
import useStore from '../store';
import { Spinner, Text } from '@chakra-ui/react';
import getDepartmentLabel from '../utils/getDepartmentLabel';
import { useTranslation } from 'react-i18next';

const QUERY_USER = gql`
	query getUserById($id: String!) {
		getUserById(id: $id) {
			id
			username
			fullName
			fullNameKhmer
			department
		}
	}
`;

const DisplayUserNameById = ({ id, onLoaded }) => {
	const { currentLang } = useStore((state) => state.currentLang);
	const { t } = useTranslation();
	const [loadUser, { error, loading, data }] = useLazyQuery(QUERY_USER);

	useEffect(() => {
		if (id) {
			loadUser({
				variables: {
					id,
				},
			});
		}
	}, [id]);

	function getDisplayName(user) {
		if (!user) return '';

		if (currentLang === 'kh') {
			return user?.fullNameKhmer || user?.fullName || user?.username || '';
		}

		return user?.fullName || user?.fullNameKhmer || user?.username || '';
	}

	function getDepartmentName(department) {
		if (!department) return '';

		const departments = department.split(',').filter(Boolean);

		return departments.map((dept) => t(getDepartmentLabel(dept))).join(', ');
	}

	const user = data?.getUserById;
	const displayName = getDisplayName(user);
	const departmentName = getDepartmentName(user?.department);

	useEffect(() => {
		if (id && user && onLoaded) {
			onLoaded(id, {
				name: displayName,
				department: departmentName,
			});
		}
	}, [id, user, displayName, departmentName]);

	if (!id) {
		return <>{t('Unknown')}</>;
	}

	return (
		<>
			{error && <Text color="red">{t('Error')}</Text>}
			{loading && <Spinner size="xs" />}
			{displayName}
			{departmentName ? <>,&nbsp;{departmentName}</> : null}
		</>
	);
};

export default DisplayUserNameById;
